export { default } from './Description';



// WEBPACK FOOTER //
// ./src/client/js/view/components/Description/index.js